/**
 * Company primary colour bridge (8.12.2): the platform-branded login uses the default tokens; authenticated pages
 * push the company colour into the ThemeProvider, which applies it only if it passes WCAG AA.
 */
import { ThemeProvider } from '@person-platform/ui';
import { useState, type ReactNode } from 'react';
import { BrandColorSetterContext } from './brand_color_setter';

export function BrandedThemeProvider({ children }: { children: ReactNode }) {
  const [brandPrimaryColor, setBrandPrimaryColor] = useState<string | null>(null);
  return (
    <BrandColorSetterContext.Provider value={setBrandPrimaryColor}>
      <ThemeProvider brandPrimaryColor={brandPrimaryColor}>{children}</ThemeProvider>
    </BrandColorSetterContext.Provider>
  );
}
